<form class="feedback-dialog" [formGroup]="form" (ngSubmit)="submit()">
  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-title">eLab Form Feedback</span>
    <button mat-icon-button type="button" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <!-- Body -->
  <div class="dialog-content">
    <!-- Error Banner -->
    <div *ngIf="error" class="submission-error">
      {{ error }}
    </div>
    <div class="form-row two-col">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" maxlength="50" />
        <mat-error *ngIf="firstName?.hasError('required')"> First name is required </mat-error>
        <mat-error *ngIf="firstName?.hasError('maxlength')"> Maximum 50 characters </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" maxlength="50" />
        <mat-error *ngIf="lastName?.hasError('required')"> Last name is required </mat-error>
        <mat-error *ngIf="lastName?.hasError('maxlength')"> Maximum 50 characters </mat-error>
      </mat-form-field>
    </div>
    <!-- Feedback Type -->
    <fieldset class="form-section">
      <legend class="section-label">Type of Feedback <span class="required-marker">*</span></legend>
      <mat-radio-group class="feedback-types" formControlName="feedbackType" aria-required="true">
        <mat-radio-button value="compliment"> Compliment </mat-radio-button>
        <mat-radio-button value="suggestion"> Suggestion </mat-radio-button>
        <mat-radio-button value="problem"> Problem </mat-radio-button>
        <mat-radio-button value="other"> Other </mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="feedbackType?.invalid && (feedbackType?.touched || submitted)"> Type of Feedback is required </mat-error>
    </fieldset>
    <!-- Message -->
    <mat-form-field appearance="outline" class="message-field">
      <mat-label>Message</mat-label>
      <textarea matInput rows="6" maxlength="1000" formControlName="message"> </textarea>
      <mat-hint align="end"> {{ message?.value?.length || 0 }} / 1000 </mat-hint>
      <mat-error *ngIf="message?.hasError('required')"> Message is required </mat-error>
      <mat-error *ngIf="message?.hasError('minlength')"> Please provide at least 10 characters </mat-error>
    </mat-form-field>
    <div class="required-note">* Required Field</div>
  </div>
  <!-- Footer -->
  <div class="dialog-actions">
    <button mat-button type="button" class="cancel-btn" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
  </div>
</form>
